// extracted by mini-css-extract-plugin
export var ProductNumber = "ProductNumber-module--ProductNumber--N4xLD";